import { render, staticRenderFns } from "./UserDashboardNotice.vue?vue&type=template&id=7fef1b05&scoped=true&"
import script from "./UserDashboardNotice.vue?vue&type=script&lang=js&"
export * from "./UserDashboardNotice.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardNotice.vue?vue&type=style&index=0&id=7fef1b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef1b05",
  null
  
)

export default component.exports